import { MutableRefObject, useEffect } from 'react';
import { INote, IResponseData } from '../global/interfaces';
import {
  IDelta,
  IImage,
  IPromptCard,
  ITranscriptSentence,
} from '@homeporter/types';
import { getWholeTranscript } from '../utils/helpers';

interface UseProcessPromptCardProps {
  booking: any; // TODO: Add proper type
  documentSection: any; // TODO: Add proper type
  context: string;
  transcriptSegments: any[]; // TODO: Add proper type
  transcriptAttachments: Record<string, any[]>; // TODO: Add proper type
  imagesMapRef: MutableRefObject<Map<string, IImage> | null>; // TODO: Add proper type
  responseChunk: IResponseData | null;
  setGenerateRequest: (request: any) => void; // TODO: Add proper type
  setBookingContext: (booking: any, context: string) => void;
  setSaveEnabled: (enabled: boolean) => void;
  regenerateIndex: number | undefined;
  setRegenerateIndex: (index: number | undefined) => void;
}

export const useProcessPromptCard = ({
  booking,
  documentSection,
  context,
  transcriptSegments,
  transcriptAttachments,
  imagesMapRef,
  responseChunk,
  setGenerateRequest,
  setBookingContext,
  setSaveEnabled,
  regenerateIndex,
  setRegenerateIndex,
}: UseProcessPromptCardProps) => {
  const handlePromptCardRegeneration = () => {
    if (
      !booking?.booking_id ||
      regenerateIndex === undefined ||
      !documentSection?.cards[regenerateIndex]
    ) {
      setGenerateRequest(undefined);
      return;
    }
    if (documentSection.cards[regenerateIndex].type !== 'Prompt') return;
    console.log(':::::regenerateIndex prompt card:', regenerateIndex);

    const promptCard = documentSection.cards[regenerateIndex] as IPromptCard;
    const _context = promptCard.context || documentSection.context || context;

    if (!documentSection.context) documentSection.context = _context;
    if (!promptCard.context) promptCard.context = _context;
    setBookingContext(booking, _context);

    const structured = !!promptCard?.structured;

    const { parts, hasImageDescriptions } = getWholeTranscript(
      transcriptSegments,
      transcriptAttachments,
      imagesMapRef,
      structured,
    );

    //*******************MOVE THIS TO THE SERVER, ASK LLM TO LIMIT RESONSE TO LESS THAN X TOKENS

    //interface INode { text: string; type: "div|ol|ul|li|h1|h2|h3"; ref: Array<string | string>; children: INode[]; }

    const format = !structured
      ? 'Use markdown to format the response'
      : `\n\nRespond only with valid JSON. Don't include any explanation or markdown, use the following format: [{text: "", type: "div|ol|ul|li|h2|h3", ref, children: […]}, …], where "ref" is an array of sentence ids that precede each sentence in the provide transcript.`;
    //: `\n\nRespond only with valid JSON of type INode[]. Don't include any explanation or markdown, use the following type definition: interface INode { text: string; type: "div|ol|ul|li|h1|h2|h3"; ref: Array<string | string>; children: INode[]; } and "ref" is an array of sentence ids that precede each sentence in the transcript.`;

    const messages = [
      {
        role: promptCard.model === 'gpt-4' ? 'system' : 'user',
        content: `${
          documentSection?.context
        }. The conversation is captured in the following transcript${
          hasImageDescriptions
            ? ', image descriptions are included in the sequence they were captured:'
            : ''
        }\n${parts.join('\n')}${format}`,
      },
      {
        role: 'user',
        content: `'${promptCard.prompt}.'`,
      },
    ];

    setGenerateRequest({
      bookingId: booking.booking_id,
      regenerateIndex,
      messages,
      model: promptCard.model,
      type: 'Prompt',
    });
  };

  useEffect(() => {
    handlePromptCardRegeneration();
  }, [regenerateIndex]);

  useEffect(() => {
    if (
      !responseChunk?.response ||
      responseChunk.bookingId === 0 ||
      responseChunk.response === undefined ||
      responseChunk.response === ''
    )
      return;

    const index = responseChunk.regenerateIndex;
    if (
      index === null ||
      index === undefined ||
      !documentSection?.cards[index] ||
      documentSection?.cards[index].type !== 'Prompt'
    )
      return;

    setSaveEnabled(true);

    const promptCard = documentSection.cards[index] as IPromptCard;
    if (promptCard.modified !== '') {
      promptCard.modified = '';
      promptCard.undo = [];
      promptCard.redo = [];
    }
    promptCard.response = responseChunk.response;

    if (responseChunk.message_id) {
      promptCard.message_id = responseChunk.message_id;
    }
  }, [responseChunk, documentSection]);

  useEffect(() => {
    if (responseChunk?.complete) {
      setRegenerateIndex(undefined);
      if (documentSection?.cards)
        console.log(
          'selectedCard:',
          documentSection.cards[responseChunk.regenerateIndex],
        );
    }
  }, [responseChunk?.complete]);
};
